export const isProd = window.location.hostname === 'falcon.arzoopro.com';
export const isTest = window.location.hostname === 'test-supplier.arzooo.com';
export const isDev = window.location.hostname === 'localhost';
